import React, { forwardRef, useImperativeHandle } from 'react';
import Api from '../../../../_helpers/Api';
import { useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import Question from '../../../modals/messages/Question'
import AddOrEdit from './AddOrEdit'
import NoDataFound from '../../../partials/NoDataFound';
import Options from './Options';
import { trans } from '../../../../_providers/Translation';

function Index(props, ref) {

    const modalRef = useRef(null)
    const deleteModalRef = useRef(null)

    const [data, setData] = useState({
        loading: true,
        data: [],

        filter: {},
        setFilter: false,
        update: false,
    });

    useImperativeHandle(ref, () => ({
        add: () => {
            handleAdd();
        }
    }));

    useEffect(() => {
        loadTypes();
    }, [data.update]);

    const loadTypes = () => {
        setData(prev => ({
            ...prev,
            loading: true
        }));

        let url = 'contractors/types';

        Api.get(url)
            .then(res => {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }));
            }).catch(err => {
                setData(prev => ({
                    ...prev,
                    loading: false
                }));
            });
    }

    // create
    const handleAdd = () => {
        modalRef.current.add();
    }

    const handleCreate = () => {
        setData(prev => ({
            ...prev,
            update: Math.random().toString()
        }))
    }

    // update
    const handleEdit = id => {
        modalRef.current.edit(id)
    }

    const handleUpdate = row => {

        let updated = data.data.map(i => {
            if (i.id == row.id) {
                i = row
            }
            return i
        });

        setData(prev => ({
            ...prev,
            data: updated,
        }))
    }

    // delete
    const handleDestroy = id => {

        let url = 'contractors/types/delete';

        Api.post(url, {
            id: id
        }).then(res => {
            if (res.data.success) {
                let filtered = data.data.filter(i => {
                    return i.id !== id
                })

                setData(prev => ({
                    ...prev,
                    data: filtered
                }))

                deleteModalRef.current.close()
            }
        })
    }

    // Question modal
    const handleDelete = id => {
        deleteModalRef.current.open(id);

        deleteModalRef.current.onSuccess(() => {
            handleDestroy(id);
        });
    }

    return (
        <>
            <AddOrEdit
                ref={modalRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Question
                ref={deleteModalRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />


            {data.loading
                ?
                <Skeleton height={45} count={10} />
                :
                data.data.length === 0
                    ?
                    <NoDataFound />
                    :
                    <>
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>
                                            {trans('tables.type')}
                                        </th>
                                        <th className="options">
                                            {trans('tables.options')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.data.map(t =>
                                        <tr key={t.id}>
                                            <td>{t.translation?.name || t.name}</td>
                                            <td className="options">
                                                {t.allow_edit &&
                                                    <Options
                                                        id={t.id}
                                                        data={t}
                                                        handleEdit={handleEdit}
                                                        handleDelete={handleDelete}
                                                    />
                                                }
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                    </>
            }

        </>
    )
}

export default forwardRef(Index);